import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './axiosBaseQuery';

let baseUrl;

const dynamicBaseQuery = args => {
    return axiosBaseQuery({ baseUrl })(args);
};

export const setBaseUrl = newBaseUrl => {
    baseUrl = newBaseUrl;
};

export default createApi({
    reducerPath: 'api',
    baseQuery: dynamicBaseQuery,
    endpoints: () => ({}),
});
